import { ApiResponse } from "../../../types/ApiResponse";
import api from "../../../utils/API";
import { ProductDTO } from "../dto";
import { Products } from "../entity";

export const getProduct = (categoryId?: string): ApiResponse<Products[]> => {
  const url = categoryId
    ? `/v1/products?productCategoryId=${categoryId}`
    : `/v1/products`;
  return api.get(url);
};

export const getAllProduct = (): ApiResponse<Products[]> =>
  api.get("/v1/products/all/status");
export const postProduct = (params: ProductDTO) =>
  api.post("/v1/products", params);
export const editProduct = ({
  id,
  params,
}: {
  id: string;
  params: ProductDTO;
}): ApiResponse<{ message: boolean }> => api.put(`/v1/products/${id}`, params);
export const deleteProduct = (id: string): ApiResponse<{ message: boolean }> =>
  api.delete(`/v1/products/${id}`);
export const getProductById = (id: string): ApiResponse<Products> =>
  api.get(`/v1/products/${id}`);

export const getProductPublic = (): ApiResponse<Products[]> =>
  api.get("/v1/public/products");

export const updateStatusProduct = ({
  id,
  status,
}: {
  id: string;
  status: string;
}): ApiResponse<{ message: boolean }> =>
  api.patch(`/v1/products/${id}/${status}`);
